/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as homescreenReducer } from "./homescreenSlice";
export {
  // Async thunks
  loadCarouselsWithRetry,
  loadMoreCarousels,
  loadMoreTiles,
  refreshCarousels,
  fetchQuickMenuShortcuts,
  // Carousel actions
  setFocusedCarouselIndex,
  setFocusedTileIndex,
  clearCarouselsError,
  // Shortcut actions
  setFocusedShortcutIndex,
  focusShortcutLeft,
  focusShortcutRight,
  setNpvrRecordingAllowed,
  updateCarouselsFromRetry,
  updateQuickMenuShortcutsFromRetry,
  // Focus routing
  setFocusedField,
  // Reset
  resetToDefaultHomescreenState,
  resetHomescreenState,
  persistHomeScreenState,
  // Carousel selectors
  selectCarousels,
  selectIsLoadingCarousels,
  selectCarouselsError,
  selectHomeScreenErrorCode,
  selectCarouselsPagination,
  selectIsLoadingMoreCarousels,
  selectTilePagination,
  selectAllTilePagination,
  selectFocusedCarouselIndex,
  selectFocusedTileIndices,
  selectRefreshIntervalSecs,
  selectLastFetchTimestamp,
  // Shortcut selectors
  selectIsLoadingShortcuts,
  selectIsShortcutsLoaded,
  selectShortcutsError,
  selectQuickMenuShortcuts,
  selectFocusedShortcutIndex,
  // Focus routing selector
  selectHomescreenFocusedField,
  selectDimmerState
} from "./homescreenSlice";
export {
  HomeScreenErrorMapper,
  getHomeScreenErrorTitle,
  getHomeScreenErrorDescription
} from "./homeScreenErrorMapper";
export type { HomescreenState } from "./homescreenTypes";
export { HomescreenFocusedField } from "./homescreenTypes";
export type { QuickMenuShortcutV4 } from "../../model/types";
export { UiDestinationTypeV4 } from "../../model/types";
export { HomeScreenDimmerState } from "./HomeScreenDimmerState";
